import type { ReactNode } from 'react';
import { Card, CardBody, Button } from 'reactstrap';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body: string;
  cta?: { label: string; onClick: () => void };
}

/**
 * Centered empty/placeholder state. Public API unchanged (icon/title/body/cta);
 * rendering migrated to a reactstrap Card (Velzon). Keeps an <h2> title for a11y.
 */
export function EmptyState({ icon, title, body, cta }: EmptyStateProps) {
  return (
    <Card className="border-0 shadow-none bg-transparent">
      <CardBody className="text-center p-5">
        {icon && (
          <div className="avatar-md mx-auto mb-3 d-inline-flex align-items-center justify-content-center fs-1 text-muted">
            {icon}
          </div>
        )}
        <h2 className="fs-18 fw-semibold mb-1">{title}</h2>
        <p className="text-muted mb-3">{body}</p>
        {cta && (
          <Button color="primary" onClick={cta.onClick}>
            {cta.label}
          </Button>
        )}
      </CardBody>
    </Card>
  );
}
